import { z } from "zod";
import { ID, TASK_NAME, TYPE, LAG_DAYS, CATEGORY, SUB_CATEGORY } from "./consts";

export const schema = z.object({
  [ID]: z.string().optional(),
  [TASK_NAME]: z.string().min(1, "This field is required"),
  [TYPE]: z.string().min(1, "This field is required"),
  [LAG_DAYS]: z.string().optional(),
  [CATEGORY]: z.string().min(1, "This Field is required"),
  [SUB_CATEGORY]: z.string().min(1, "This Field is required"),
});

export type formValues = z.infer<typeof schema>;
